var map = {
	"./background.jpg": 28,
	"./bg.png": 29,
	"./flags/be.svg": 30,
	"./flags/cn.svg": 31,
	"./flags/de.svg": 32,
	"./flags/es.svg": 33,
	"./flags/fr.svg": 34,
	"./flags/gb.svg": 35,
	"./flags/it.svg": 36,
	"./flags/jp.svg": 37,
	"./flags/us.svg": 38,
	"./icons/arrow.svg": 39,
	"./icons/back.svg": 40,
	"./icons/chevron.svg": 41,
	"./icons/close.svg": 42,
	"./icons/deco.svg": 43,
	"./icons/download.svg": 44,
	"./icons/error.svg": 45,
	"./icons/facebook.svg": 46,
	"./icons/glass.svg": 47,
	"./icons/info.svg": 48,
	"./icons/instagram.svg": 49,
	"./icons/linkedin.svg": 50,
	"./icons/marker.svg": 51,
	"./icons/pinterest.svg": 52,
	"./icons/play.svg": 53,
	"./icons/point.svg": 54,
	"./icons/shop.svg": 55,
	"./icons/slider-arrow.svg": 56,
	"./icons/star.svg": 57,
	"./icons/success.svg": 58,
	"./icons/twitter.svg": 59,
	"./icons/weibo.svg": 60,
	"./icons/youtube.svg": 61,
	"./logo-footer.png": 62,
	"./logo-secondary.svg": 63,
	"./logo-top.svg": 64,
	"./logo.png": 65,
	"./marker.svg": 66,
	"./pattern-secondary.png": 67,
	"./pattern.png": 68,
	"./quote.svg": 69,
	"./texture-menu.jpg": 70,
	"./textures.jpg": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;